export const LIST_FORMA_PAGO = 'LIST_FORMA_PAGO';